'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasOfficeHoursMessageFromCurrentSession = undefined;

var _isOfficeHoursMessage = require('../../pubnub-message/operators/isOfficeHoursMessage');

var _getMessageIsApproximatelyFromCurrentSession = require('../../pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _hasMessages = require('./hasMessages');

var _getMessages = require('./getMessages');

var hasOfficeHoursMessageFromCurrentSession = exports.hasOfficeHoursMessageFromCurrentSession = function hasOfficeHoursMessageFromCurrentSession(threadHistory) {
  if (!(0, _hasMessages.hasMessages)(threadHistory)) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(threadHistory);

  var lastOfficeHoursMessage = messages.findLast(_isOfficeHoursMessage.isOfficeHoursMessage);

  return !!(lastOfficeHoursMessage && (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(lastOfficeHoursMessage));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasOfficeHoursMessageFromCurrentSession.js
// module id = 758
// module chunks = 2 3